module.exports = __webpack_public_path__ + "static/collectorcans-jd-yellow-artwork-ff813a901d6fabe802c4d82984dcf8f9.png";